export default {"src":"/_next/static/media/circleClose_24.ac0f7d49.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};